import { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { setupInterceptors } from "./axiosInstance";

const InjectAxiosInterceptors = () => {
  const history = useHistory();
  const { logoutUser } = useContext(AuthContext);

  useEffect(() => {
    setupInterceptors(history, logoutUser);
  }, [history, logoutUser]);

  //not render anything
  return null;
};

export default InjectAxiosInterceptors;
